import { render } from "./dashboard-activations.vue?vue&type=template&id=a58eb350"
import script from "./dashboard-activations.vue?vue&type=script&lang=js"
export * from "./dashboard-activations.vue?vue&type=script&lang=js"
script.render = render

export default script